import {SODeleteRoleGrant} from '../../core/role-grant/so-delete-role-grant';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteRoleGrant extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteRoleGrant;
}